<h1>Lagerorte</h1>

<div class="form-box">
  <mat-form-field class="search-field">
    <mat-label>Suchen</mat-label>
    <input
      matInput
      [value]="searchTerm()"
      (input)="search($any($event.target).value)"
    />
    @if (searchTerm()) {
      <button
        matIconButton
        matSuffix
        type="button"
        aria-label="Suche zurücksetzen"
        (click)="search('')"
      >
        <mat-icon>clear</mat-icon>
      </button>
    } @else {
      <mat-icon matSuffix>search</mat-icon>
    }
  </mat-form-field>

  @if (store.loading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="table-container">
    <table mat-table [dataSource]="store.entities()">
      @for (column of columnConfig; track column.name) {
        <ng-container
          [matColumnDef]="
            column.nestedName && column.useNestedName
              ? (column.refName | getNestedName: column.nestedName)
              : column.refName
          "
        >
          <th mat-header-cell *matHeaderCellDef>{{ column.name }}</th>
          <td mat-cell *matCellDef="let element">
            {{
              column.nestedName
                ? (element
                  | getNestedObject
                    : column.refName
                    : column.nestedName
                    : column?.fallback)
                : (element[column.refName] ?? column?.fallback)
            }}{{ column.suffix }}
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="storage-location-row"
        (click)="navigateToArticles(row)"
      ></tr>
      <tr class="mat-mdc-row" *matNoDataRow>
        <td
          class="mat-mdc-cell no-data-cell"
          [attr.colspan]="displayedColumns.length"
        >
          @if (!store.loading()) {
            Keine passenden Lagerorte gefunden.
          }
        </td>
      </tr>
    </table>
  </div>

  <mat-paginator
    [length]="store.total()"
    [pageIndex]="store.pageIndex()"
    [pageSize]="store.pageSize()"
    [pageSizeOptions]="pageSizeOptions"
    (page)="changePage($event)"
  >
  </mat-paginator>
</div>
